import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | ICSI 2024" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">

          <h3 id="session1">
            Special Session 1: &quot;Unleashing the Power of Swarms: Exploring Autonomous Decision-Making for Multi-Agent Unmanned Systems&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>

          {/* <h3 id="session2">
            Special Session 2: &quot;Bridging the Gap: From Single Agents to Collaborative Swarms - Advancing Multi-Agent Learning for Real-World Challenges&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <h3 id="session3">
            Special Session 3: &quot;Multi-Agent Systems: A New Frontier in Machine Learning, Driving Real-World Solutions&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <h3 id="session4">
            Special Session 4: &quot;Emerging Trends and Challenges in Multi-Agent Systems: A Comprehensive Analysis and Future Directions&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3> */}
          <p>
            Multi-agent systems are an emerging research hotspot and application direction in the field of machine learning. They cover a wide range of algorithms, rules, and frameworks, and are widely applied in real-world domains such as autonomous driving, energy allocation, formation control, trajectory planning, routing planning, and social problems , with high research value and significance.<br></br>
            Multi-agent systems have the characteristics of autonomy, distribution, and coordination, and have the capabilities of self-organization, learning, and reasoning.The collaboration of multi-agent swarms involves difficulties such as cross-domain platforms, diverse missions, communication denial, and high time sensitivity, which leads to autonomous decision-making problems with high-dimensional, pathological, strong nonlinearity, and high dynamics. This poses a great challenge to the autonomous combat planning and ad hoc decision-making of swarms.<br></br>
            This special session focuses on the problem of autonomous decision-making for multi-agent unmanned swarms. Based on the situation acquisition, target analysis, and detection and maneuvering processes underlying the decision-making requirements, a distributed multi-agent autonomous decision-making model is constructed by fusing multiple networks.
            The research purpose of this session is to improve the convergence and generalization performance in the case of incomplete situation information, establish a prototype verification system for distributed multi-agent decision-making, crack the autonomous decision-making problem of multi-agent systems, and provide solid support for the design of control systems for unmanned swarms.<br></br>
            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Conduct in-depth and meticulous analysis of multi-agent collaboration problems, using cutting-edge technologies to conduct comprehensive research on the learning mechanisms, communication mechanisms, behavioral consistency, and knowledge transfer of multi-agents.
              </li><li>Conduct research on multi-agent learning paradigms, such as centralized learning paradigms, independent learning paradigms, and centralized training-distributed execution paradigms, in response to the many challenges of extending single-agent learning to multi-agent systems.
              </li><li>Use cutting-edge technologies (such as hierarchical reinforcement learning) to optimize the learning process to achieve the ability to adjust decisions dynamically in response to the difficulty of ad hoc dynamic adjustment and the complexity of decision-making for multi-agents.
              </li><li>To enhance the ability of multi-agent systems to solve group intelligence problems, research on the scalability and strategy transferability of models.
              </li><li>Construct multi-agent models for the autonomous decision-making problem of cross-domain unmanned swarms.
              </li><li>Research and develop suitable training platforms for the training and testing of multi-agent systems.
              </li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2024 instruction for authors and submit your
            paper via the ICSI 2024 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS1 &quot;
            </strong>{" "} Unleashing the Power of Swarms: Exploring Autonomous Decision-Making for Multi-Agent Unmanned Systems
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                {/* <td>Email</td> */}
              </tr>
              <tr>
                <td>Edmond Q. Wu</td>
                <td>Shanghai Jiao Tong University</td>
                {/* <td>drniuben@gmail.com</td> */}
              </tr>
              <tr>
                <td>Xiangyang Deng</td>
                <td>Naval Aeronautical University</td>
                {/* <td>tianwei@szu.edu.cn</td> */}
              </tr>

            </table>
          </p>

          <p>

            Edmond Q. Wu (Senior Member, IEEE) received the Ph.D. degree in controlling theory and engineering from Southeast University, Nanjing, China, in 2009. He is a Professor with the Key Laboratory of System Control and Information Processing, Ministry of Education, Shanghai Jiao Tong University, China. His research interests include brain-computer cooperative control flight, brain-inspired network and human-machine interaction. He is supported by the National Science Fund for Distinguished Young Scholars. He is an Associate Editor of IEEE Transactions on Systems, Man, and Cybernetics: Systems, IEEE Transactions on Neural Networks and Learning Systems, IEEE Transactions on Intelligent Transportation Systems and IEEE Transactions on Intelligent Vehicles.

          </p>
          <p>
            Xiangyang Deng received the Ph.D degree in information and communication engineering from Naval Aeronautical University in 2012. From 2022 to 2023, he was a visiting scholar in Tsinghua University. He is currently a associate professor with Naval Aeronautical University, China. His research interests include swarm intelligence, multi-agent system and behaviour imitation. He is supported by the military&apos;s high-level scientific and technological innovation talent project.

          </p>

          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>












          <h3 id="session2">
            Special Session 2: &quot;Data Analysis and Security in Swarm Intelligence&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            As the realm of swarm intelligence continues to evolve, the complexity of interconnected systems, including multi-agent systems, swarm robotics, and distributed artificial intelligence, is reaching new heights. These systems, perpetually generating and transmitting data, have the potential to revolutionize industries from logistics to smart city planning. However, the management of such vast amounts of data on swarm intelligence networks is a challenging task. Improper handling can lead to data breaches and compromise user privacy, resulting in significant losses for both individuals and organizations. Thus, the need for robust data analysis, encryption, and governance is paramount. This special session is dedicated to presenting the most recent advances in data analysis and security within the context of swarm intelligence.
            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Privacy preserving of swarm intelligence data</li>
              <li>Attacks and defenses in swarm intelligence</li>
              <li>Data analysis and security challenges in swarm intelligence systems</li>
              <li>Machine learning algorithms for uncertain data in swarm intelligence systems</li>
              <li>Analysis of security vulnerabilities in swarm intelligence networks</li>
              <li>Blockchain-based solutions for data security in swarm intelligence</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2024 instruction for authors and submit your
            paper via the ICSI 2024 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS2 &quot; -- the Special Session on  Data Analysis and Security in Swarm Intelligence
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Jiwei Zhang</td>
                <td>Beijing University of Posts and Telecommunications</td>
                <td>jwzhang666@bupt.edu.cn</td>
              </tr>
              <tr>
                <td>Haoyang Yu</td>
                <td>Beijing University of Posts and Telecommunications</td>
                <td>yuhaoyang@bupt.edu.cn</td>
              </tr>
              <tr>
                <td>Jiaen Zhou</td>
                <td>Beijing University of Posts and Telecommunications</td>
                <td>circularje@bupt.edu.cn</td>
              </tr>
              <tr>
                <td>Hongtao Yang</td>
                <td>Beijing Polytechnic College</td>
                <td>yanght@bgy.edu.cn</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>



          <h3 id="session3">
            Special Session 3: &quot;Research on Swarm Intelligence Optimization Algorithm Based on Large Language Model&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Large Language Models (LLMs) represent a significant leap in AI, capable of understanding context, generating coherent text, and performing various language tasks with impressive accuracy. These models have been trained on extensive datasets and can mimic human-like language understanding and generation. Despite their advanced capabilities, LLMs face challenges in areas like computational efficiency, adaptability to new and evolving data, and depth of context understanding. <br></br>

            Swarm Intelligence Optimization Algorithms, drawing inspiration from natural phenomena such as the collective behavior of bird flocks or ant colonies, offer a unique approach to problem-solving. Algorithms like Particle Swarm Optimization (PSO) and Fireworks Algorithm (FWA) exemplify this approach, known for efficiently navigating complex, multi-dimensional search spaces. These algorithms excel in optimizing non-linear and intricate functions, which is instrumental in enhancing decision-making and problem-solving aspects of various computational tasks.
            <br></br>
            In this special session, we will explore how the advanced data processing and pattern recognition capabilities of LLMs can contribute to the evolution of swarm intelligence algorithms. Discussions will revolve around novel approaches for applying LLMs to improve the design, implementation, and effectiveness of swarm intelligence methods. Topics will include leveraging LLMs for better algorithmic strategies, enhancing decision-making processes in swarm algorithms, and exploring the adaptability and scalability of these algorithms in diverse applications.
            <br></br>

            By bridging the gap between LLMs and swarm intelligence, this session aims to foster innovative research and collaboration, paving the way for significant advancements in both fields. We anticipate that this interdisciplinary approach will not only enhance our understanding of swarm intelligence algorithms but also expand the potential applications of LLMs in various AI-driven solutions.

            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li> <b>Enhancing Swarm Intelligence Algorithms with LLMs</b>: Exploring how large language models can contribute to the design and refinement of swarm intelligence algorithms.</li>
              <li> <b>Data Processing and Analysis in Swarm Intelligence</b>: Leveraging LLMs for advanced data processing, pattern recognition, and analysis in swarm intelligence systems.</li>
              <li> <b>Algorithmic Strategy and Decision Making</b>: Utilizing LLMs to improve decision-making processes and strategic planning in swarm intelligence optimization.</li>
              <li> <b>Adaptability and Dynamic Learning</b>: Investigating the role of LLMs in enhancing the adaptability and learning mechanisms of swarm intelligence algorithms in dynamic environments.</li>
              <li> <b>Scalability of Swarm Algorithms</b>: Exploring how LLMs can aid in scaling swarm intelligence algorithms for large-scale and complex problem-solving scenarios.</li>
              <li> <b>Cross-Domain Applications</b>: Discussing the application of LLM-enhanced swarm intelligence algorithms in various fields such as robotics, logistics, environmental modeling, and healthcare.</li>
              <li> <b>Model evaluation</b>: Analyzing the performance of LLM-enhanced swarm intelligence algorithms against traditional methods.</li>
              <li> <b>Integration Challenges and Solutions</b>: Addressing the technical and conceptual challenges in integrating LLMs with swarm intelligence optimization algorithms.</li>

            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2024 instruction for authors and submit your
            paper via the ICSI 2024 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS3 &quot; -- the Special Session on Research on Swarm Intelligence Optimization Algorithm Based on Large Language Model
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ying Tan</td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Shipeng cen</td>
                <td>Peking University</td>
                <td>censhipeng@pku.edu.cn</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>

          <h3 id="session4">
            Special Session 4: &quot;Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Addressing highly complex combinatorial optimization problems with multiple objectives and various real-world constraints, which are intractable to exact methods, presents to be one of current research challenges in evolutionary computation. With the rapid development of computation power and artificial intelligence, machine learning and swarm intelligence have become promising tools. Machine learning algorithms, such as the reinforcement learning algorithms, have shown strong ability in interactive learning environment. Swarm intelligence algorithms, inspired by the behavior in self-organized groups, such as birds, ants, bacteria, etc., hold the superiority in solving complex optimization problems. How to utilize swarm intelligence algorithms and machine learning algorithms to deal with combinatorial optimization problem remains to be an interesting topic and has attracted attentions from both researchers and engineers.
            <br></br>
            <br></br>

            The objective of this special session is to gather recent theoretical contributions in machine learning and swarm intelligence fields. And it also collects unpublished methods for practical combinatorial optimization problems.


            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Theoretical contributions in machine learning algorithms: reinforcement learning, deep learning, machine learning, meta-learning, etc;</li>
              <li>Unpublished ideas in swarm intelligence algorithms: particle swarm optimization, bacterial foraging optimization, genetic algorithm, hydrological cycle optimization, grey wolf optimization, artificial fish search algorithm, etc;</li>
              <li>Efficient methods for combinatorial optimization problems such as vehicle routing problem, nurse scheduling, etc;</li>
              <li>Original work towards multi-objective problems, multi-task problems and constrained problems;</li>
              <li>Other Intelligent Computing and Swarm Intelligence Related Algorithms and Applications.</li>


            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2024 instruction for authors and submit your
            paper via the ICSI 2024 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS4 &quot; -- the Special Session on Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ben Niu</td>
                <td>Shenzhen University</td>
                <td>drniuben@gmail.com</td>
              </tr>
              <tr>
                <td>Wenjie Yi</td>
                <td>Shenzhen University</td>
                <td>wenjie.yi@szu.edu.cn</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>



          <h3 id="session5">
            Special Session 5: &quot;Biologically Inspired Intelligence for Mechatronics and Robotics&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Biologically inspired intelligence technique, an important embranchment of series on computational intelligence, plays a crucial role for robotics. The autonomous robot and vehicle industry has had an immense impact on our economy and society, and this trend will continue with biologically inspired intelligence techniques. Biologically inspired intelligence, such as biologically inspired neural networks (BINN), is about learning from nature, which can be applied to the real-world robot and vehicle systems. Recently, the research and development of bio-inspired systems for robotic applications is increasingly expanding worldwide. Biologically inspired algorithms contain emerging sub-topics such as bio-inspired neural network algorithms, brain-inspired neural networks, swam intelligence with BINN, ant colony optimization algorithms (ACO) with BINN, bee colony optimization algorithms (BCO), particle swarm optimization with BINN, immune systems with BINN, and biologically inspired evolutionary optimization and algorithms, etc. Additionally, it is decomposed of computational aspects of bio-inspired systems such as machine vision, pattern recognition for robot and vehicle systems, motion control, motion planning, movement control, sensor-motor coordination, and learning in biological systems for robot and vehicle systems.
            <br></br>
            <br></br>
            This special session seeks to highlight and present the growing interests in emerging research, development and applications in the dynamic and exciting areas of biologically inspired algorithms for mechatronics and robotics and vehicle systems (autonomous robots, unmanned underwater vehicles, and unmanned aerial vehicles).
            <br></br>
            <br></br>
            Original research papers are solicited in related areas of biologically inspired algorithms for robotics. Submissions to the Special Session should be focused on theoretical results or innovative applications of computational intelligence of biologically inspired algorithms (such as BINN) for robot and vehicle systems.
            {" "}

          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Evolutionary optimization, machine vision, pattern recognition for robot and vehicle systems</li>
              <li>Biologically inspired neural networks for mechatronics and robotics</li>
              <li>Deep neural networks and learning systems for robotics such as motion planning, navigation, mapping, localization, image processing, etc</li>
              <li>Bio-inspired system on computer vision and image progressing for mechatronics and robotics</li>
              <li>Human-like learning for mechatronics and robotics</li>
              <li>Theory, design, and applications of neural networks and related learning systems for mechatronics, robotics and vehicles</li>
              <li>Neuro-dynamics based models for mechatronics, robot and vehicle systems</li>
              <li>Brain-inspired neural networks for robotics, and mechatronics</li>
              <li>Swarm intelligence for mechatronics and robotics</li>
              <li>Evolutionary neuro-computing for robot and vehicle systems</li>
              <li>Bio-inspired system on machine learning, intelligent systems design for mechatronics and robotics</li>
              <li>Cellular automata for mechatronics and robotics</li>
              <li>Immune systems with BINN for mechatronics and robotics</li>
              <li>Ant colony optimization algorithms (ACO) with BINN for mechatronics and robotics</li>
              <li>Bee colony optimization algorithms (BCO) with BINN for mechatronics and robotics.</li>


            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2024 instruction for authors and submit your
            paper via the ICSI 2024 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS5 &quot; -- the Special Session on Biologically Inspired Intelligence for Mechatronics and Robotics
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Tingjun Lei</td>
                <td>Mississippi State University</td>
                <td>tl1320@msstate.edu</td>
              </tr>
              <tr>
                <td>Dr. Chaomin Luo</td>
                <td>Mississippi State University</td>
                <td>Chaomin.Luo@ece.msstate.edu</td>
              </tr>

              <tr>
                <td>Dr. Zhuming Bi</td>
                <td>University Fort Wayne, Fort Wayne</td>
                <td>biz@pfw.edu</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>









          {/* <div className="call-sp">
            <h2>ICSI 2024 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              ICSI 2024 technical program will include special sessions. Their aim
              is to provide a complementary flavor to the regular sessions and
              should include hot topics of interest to the swarm intelligence
              community that may also go beyond disciplines traditionally
              represented at ICSI.
            </p>
            <p align="justify">
              Prospective organizers of special sessions should submit proposals
              indicating:
            </p>
            <p align="left">
              * Title of the session.
              <br />
              * Rationale of the need for the special session at ICSI.
              <br />
              <em>
                The rationale should stress the novelty of the topic and/or its
                multidisciplinary flavor, and must explain how it is different
                from the subjects covered by the regular sessions.
              </em>
              <br />
              * Short biography of the organizers.
              <br />* List of 5 – 6 contributed papers (including titles, authors,
              contact information of the corresponding author){" "}
              <em>
                (this can also be provided later when they become available).
              </em>
            </p>
            <p align="justify">
              Proposals are due on or before January 31, 2024and should be sent
              via e-mail (in either pdf or plain ASCII text form) to the special
              sessions chair (to be announced) and forward to ICSI 2024
              secretariat at
              <a href="mailto:icsi2024@iasei.org">icsi2024@iasei.org</a>.
            </p>
            <p align="justify">
              Proposals will be evaluated based on the timeliness of the topic,
              the qualifications of the organizers and the authors of the papers
              proposed in the session. In its decision, the committee will try to
              realize a balance of the topics across the technical areas
              represented in swarm intelligence.
            </p>
            <p align="justify">
              Notification of acceptance will be sent to the organizers no later
              than January 31, 2024. Authors of papers included in approved
              special sessions should submit their manuscript on or before January
              30, 2024. Manuscripts should conform to the formatting and
              electronic submission guidelines of regular ICSI papers (Springer’s
              LNCS format).
            </p>
            <p>
              When they submit papers, there is a choice to indicate that their
              papers are special session papers which will also undergo peer
              review. It is the responsibility of the organizers to ensure that
              their special session meets the ICSI quality standards. If, at the
              end of the review process, less than four papers are accepted, the
              session will be canceled and the accepted papers will be moved to
              regular sessions.
            </p>
          </div>

          <br /><br />
          <hr></hr>
          <br /><br /> */}





        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default SpecialSession;
